import React from 'react'
import logo from "../../assets/boxxdocks-logo-grey.svg"
import done from "../../assets/confirm.svg"


const Confirmation = () => {



  const DoneHandler = () => {
    localStorage.removeItem("getServicePage");
    window.location.href = "https://www.boxxdocks.com/";
    //window.open("https://www.boxxdocks.com/", "_blank");
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="main-content">
            <div className="logo mx-auto">
              <img src={logo} className="img-fluid mx-auto" alt="" />
            </div>
            <p className="mb-0 heading">Your feedback has been <br /> successfully submitted!</p>
            <div className="code-box">
              <div className="logo mx-auto d-flex">
                <img src={done} className="img-fluid mx-auto" alt="" />
              </div>
              <div className="button-box">
                <button type="button" className="btn-continue" onClick={DoneHandler}>Done</button>

              </div>

            </div>



          </div>
        </div>
      </div>
    </div>

  )
}

export default Confirmation